/* eslint no-undef: 0 */
'use strict';
exports.default = exports;
/*
Tag deve seguir o IETF's BCP 47, https://www.w3.org/International/articles/language-tags/

 Ao adicionar um novo idioma, adicionar também em src/plugins/vuetify.js

 */

exports.i18nConfig = {
  fallbackLocale: 'pt-BR',
  dateTimeFormats: {
    // 'en-US': {
    //   numeric: {
    //     year: 'numeric', month: 'numeric', day: 'numeric'
    //   },
    //   short: {
    //     year: 'numeric', month: 'short', day: 'numeric'
    //   },
    //   long: {
    //     year: 'numeric', month: 'short', day: 'numeric',
    //     hour: 'numeric', minute: 'numeric', hour12: false
    //   },
    //   veryLong: {
    //     year: 'numeric', month: 'short', day: 'numeric',
    //     weekday: 'short', hour: 'numeric', minute: 'numeric', hour12: false
    //   }
    // },
    'pt-BR': {
      numeric: {
        year: 'numeric', month: 'numeric', day: 'numeric'
      },
      short: {
        year: 'numeric', month: 'short', day: 'numeric'
      },
      long: {
        year: 'numeric', month: 'short', day: 'numeric',
        hour: 'numeric', minute: 'numeric', hour12: false
      },
      veryLong: {
        year: 'numeric', month: 'short', day: 'numeric',
        weekday: 'short', hour: 'numeric', minute: 'numeric', hour12: false
      }
    }
  },
  numberFormats: {
    // 'en-US': {
    //   currency: {
    //     style: 'currency',
    //     currency: 'BRL',
    //     currencyDisplay: 'symbol'
    //   }
    // },
    'pt-BR': {
      currency: {
        style: 'currency',
        currency: 'BRL',
        currencyDisplay: 'symbol',
        symbol: 'R$'
      }
    }
  },
  silentTranslationWarn: true,
  silentFallbackWarn: true
};

exports.languages = {
  // 'en-US': {
  //   flag: 'us',
  //   name: 'English',
  //   database: 'en',
  //   hreflang: 'en_US',
  //   vuetify: 'en',
  //   iso: 'en-US',
  // },
  'pt-BR': {
    flag: 'br',
    name: 'Português',
    database: 'ptbr',
    hreflang: 'pt_BR',
    vuetify: 'pt',
    iso: 'pt-BR',
  }
};

/**
 *
 * @type {({database: string, flag: string, hreflang: string, iso: string, name: string})[]}
 */
exports.languagesList = [
  exports.languages['pt-BR'],
];

exports.languagesFiles = {
  'pt-BR': require('./pt-BR.js')
};

exports.getLocale = function(inputLocale) {
  return exports.fcmBestAvailableLocale(Object.keys(exports.languages), exports.i18nConfig.fallbackLocale,
    inputLocale,
    storageGetItem('locale') || [],
    typeof navigator!=='undefined'?(navigator.languages || [navigator.language]):[]);
};


exports.getLocalePriority = function(inputLocale) {
  return exports.fcmBestAvailableLocale(Object.keys(exports.languages), exports.i18nConfig.fallbackLocale,
    ...inputLocale,
    storageGetItem('locale') || [],
    typeof navigator!=='undefined'?(navigator.languages || [navigator.language]):[]);
};

exports.setLocale =  function(locale) {
  console.log('setLocale', locale);
  if(locale) {
    storageSetItem('locale', locale);
  }
};

// Baseado na BestAvailableLocale abstract operation
// https://tc39.github.io/ecma402/#sec-bestavailablelocale
exports.fcmBestAvailableLocale = function(availableLocales, fallback, ...localePriority) {
  try {
    if(!Array.isArray(availableLocales)) {
      if(availableLocales) {
        availableLocales = [availableLocales];
      }
      else {
        return fallback;
      }
    }
    availableLocales = availableLocales.map((locale) =>
      locale
        .split('-')
        .map((localePart) => localePart.toLowerCase())
        .join('-')
    );

    let last = 0;
    for (let i = 0; i < localePriority.length; i++) {
      if(!Array.isArray(localePriority[i])) {
        if(localePriority[i]) {
          localePriority[i] = [localePriority[i]];
        }
        else {
          localePriority[i] = [];
          continue;
        }
      }
      localePriority[i] = localePriority[i].map((locale) =>
        locale
          .split('-')
          .map((localePart) => localePart.toLowerCase())
          .join('-')
      );

      for(let j = 0; j<localePriority[i].length; j++) { // buscando locale identico
        if(availableLocales.includes(localePriority[i][j])) {
          return Intl.getCanonicalLocales(localePriority[i][j])[0];
        }
      }

      for(let j = 0; j<localePriority[i].length; j++) { // buscando locale parecido
        let subLocale = localePriority[i][j];
        while(subLocale && subLocale.length>1) {
          for(let k = 0; k<availableLocales.length;k++) {
            if(availableLocales[k].indexOf(subLocale)===0) {
              return Intl.getCanonicalLocales(availableLocales[k])[0];
            }
          }
          last = subLocale.lastIndexOf('-');
          if(last===-1) {
            break;
          }
          subLocale = subLocale.substr(0, last);
        }
      }
    }
  }catch(err) {
    console.error('invalid availableLocales',err);
  }
  return fallback;
};




/*
  Operação de tradução para o node server, para o Vue utilizar o plugin vue-i18n já devidamente configurado no Vue
 */

exports.translate = function(locale, key, objValues = null) {
  let res = key.split('.').reduce(function(o, k) {
    return o && o[k];
  }, exports.languagesFiles[locale]);

  if(typeof res!=='undefined') {
    if(objValues) {
      return res.replace(/\{([^}]+)}/gi, function(matched, key) {
        return objValues[key] || matched;
      });
    }
    return res;
  }

  res = key.split('.').reduce(function(o, k) {
    return o && o[k];
  }, exports.languagesFiles[exports.i18nConfig.fallbackLocale]);

  if(typeof res!=='undefined') {
    if(objValues) {
      return res.replace(/\{[^}]+}/gi, function(matched) {
        return objValues[matched.substring(1, matched.length-1)] || '';
      });
    }
    return res;
  }
  return key;
};

exports.translateDb = function(locale, obj) {
  if(typeof obj==='string') {
    return obj;
  }
  if(exports.languages[locale] && obj && obj[exports.languages[locale].database]) {
    return obj[exports.languages[locale].database];
  }
};




exports.formatCurrency = function(locale, input, currency, currencyDisplay) {
  if(!exports.i18nConfig.numberFormats[locale]) {
    console.warn('i18n Locale not found', locale);
  }
  return Number(input).toLocaleString(locale,
    {
      style: 'currency',
      currency: currency || exports.i18nConfig.numberFormats[locale]?.currency?.currency || 'BRL',
      currencyDisplay: currencyDisplay || exports.i18nConfig.numberFormats[locale]?.currency?.currencyDisplay || undefined
    });
};

exports.currencyExcel = function(locale, input, currency, currencyDisplay) {
  if(!exports.i18nConfig.numberFormats[locale]) {
    console.warn('i18n Locale not found', locale);
  }
  const symbol = exports.i18nConfig.numberFormats[locale]?.currency?.symbol || 'R$';
  return {t: 'n', z: `"${symbol} "#,##0.00_);\\("${symbol} "#,##0.00\\)`, v: input};
};

/**
 *
 * @param req
 * @param extraLang
 * @param getPathCloudFunctions
 * @returns {{isDark: boolean, t: (function(*, Object=): *), currencyExcel: (function(*): {t: string, v: *, z: string}), pathCloudFunctions: string, trdb: (function(*): string|*), locale: *, formatCurrency: (function(*): string), locale_: *}}
 */
exports.getLocalEnvironment = function(req, extraLang = null, getPathCloudFunctions=false) {
  let lang = [];
  let isDark = false;
  let pathCloudFunctions = '';
  if(extraLang) {
    if ('string' === typeof extraLang) {
      lang = [extraLang];
    }
    else if (Array.isArray(extraLang)) {
      lang = extraLang;
    }
  }
  if(req) {
    if(req.query && req.query.lang) {
      lang.push(req.query.lang);
    }
    if(req.params && req.params.lang) {
      lang.push(req.params.lang);
    }
    if(req.acceptsLanguages) {
      const tmp = req.acceptsLanguages();
      lang = lang.concat(tmp);
    }
    if(req.query && req.query.isDark) {
      isDark = JSON.parse(req.query.isDark) || false;
    }
    if(getPathCloudFunctions) {
      for(let i=0;i<((req.url ||'').split('/').length-2);i++) {
        pathCloudFunctions += '../';
      }
    }
  }
  const locale = exports.getLocalePriority(lang);
  return {
    t: function(key, objValues = null) {
      return exports.translate(locale, key, objValues);
    },
    trdb: function(key) {
      return exports.translateDb(locale, key);
    },
    formatCurrency: function(input) {
      return exports.formatCurrency(locale, input);
    },
    currencyExcel: function(input) {
      return exports.currencyExcel(locale, input);
    },
    locale: locale,
    locale_: locale.replace(/-/g, '_'),
    isDark: isDark,
    pathCloudFunctions: pathCloudFunctions,
  };
};

function storageGetItem(key) {
  try {
    return window.localStorage.getItem(key);
    // eslint-disable-next-line
  } catch(err) {}
}

function storageSetItem(key, string) {
  try {
    return window.localStorage.setItem(key, string);
    // eslint-disable-next-line
  } catch(err) {}
}


